var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-login-box',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('h1',[_vm._v("Login (impersonating)")]),_c('app-loading',{attrs:{"loading":_vm.loading}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }